import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

// apparently re-exporting types breaks Vite (https://github.com/vitejs/vite/issues/2117 - and they won't fix it).
// So rather than using import mappings I have had to make the imports explicit.

export const NavLink: React.FC<{
  children?: ReactNode;
  active: boolean;
  href?: string;
  className?: string;
  onClick: () => {};
  ['data-testid']: string;
}> = ({ children, active = false, href = null, className = '', onClick = () => {}, ...props }) => {
  if (!href) {
    return (
      <button
        className={`nav-link ${className} ${active ? 'active' : ''}`}
        {...props}
        data-testid={props['data-testid']}
        onClick={onClick}
      >
        {children}
      </button>
    );
  }

  return (
    <Link className={`nav-link ${className} ${active ? 'active' : ''}`} to={href} {...props} onClick={onClick}>
      {children}
    </Link>
  );
};
